import { StepIcon, type StepIconSvgType } from '@poseidon/components/StepIcon';

type CadenceStepsListTypeInt<T extends StepIconSvgType = StepIconSvgType> = {
  label: string;
  labelFull: string;
  labelFullIfResponse: string;
  value: T;
  icon: React.JSX.Element;
  error?: string;
};

const messageStep = {
  label: 'Message',
  labelFull: 'Send Linkedin message',
  labelFullIfResponse: 'Respond with Linkedin message',
  value: 'message',
  icon: <StepIcon iconType="message" />,
  error: 'You are not connected to this contact.',
} as const satisfies CadenceStepsListTypeInt;

const inmailStep = {
  label: 'InMail',
  labelFull: 'Send Linkedin Inmail',
  labelFullIfResponse: 'Respond with Linkedin message',
  value: 'inmail',
  icon: <StepIcon iconType="inmail" />,
  error: 'You are already connected.',
} as const satisfies CadenceStepsListTypeInt;

export const callStep = {
  label: 'Call',
  labelFull: 'Call contact',
  labelFullIfResponse: 'Make a phone call',
  value: 'call',

  icon: <StepIcon iconType="call" />,
  error: 'There is no phone number assigned, enrich the contact to find one.',
} as const satisfies CadenceStepsListTypeInt;

export const voiceNoteStep = {
  label: 'Voice Note',
  labelFull: 'Send a voice note',
  labelFullIfResponse: 'Send a voice note',
  value: 'voice_note',

  icon: <StepIcon iconType="voice_note" />,
  error: 'You can not send voice drops',
} as const satisfies CadenceStepsListTypeInt;

export const connectStep = {
  label: 'Connect',
  labelFull: 'Send Linkedin Connection',
  labelFullIfResponse: 'Send Linkedin Connection',
  value: 'connect',

  icon: <StepIcon iconType="connect" />,
  error: 'You are already connected.',
} as const satisfies CadenceStepsListTypeInt;

export const visitStep = {
  label: 'Visit',
  labelFull: 'Visit Linkedin profile',
  labelFullIfResponse: 'Visit Linkedin profile',
  value: 'visit',

  icon: <StepIcon iconType="visit" />,
} as const satisfies CadenceStepsListTypeInt;

export const emailStep = {
  label: 'Email',
  labelFull: 'Send Email',
  labelFullIfResponse: 'Respond with Email',
  value: 'email',

  icon: <StepIcon iconType="email" />,
  error: 'There is no email address assigned, enrich the contact to find one.',
} as const satisfies CadenceStepsListTypeInt;
export const manualStep = {
  label: 'Task',
  labelFull: 'Get reminded',
  labelFullIfResponse: 'Get reminded',
  value: 'reminder',

  icon: <StepIcon iconType="reminder" />,
} as const satisfies CadenceStepsListTypeInt;
export const likeRecentPostsStep = {
  label: 'Like',
  labelFull: 'Like recent posts',
  labelFullIfResponse: 'Like recent posts',
  value: 'likeRecentPosts',
  icon: <StepIcon iconType="likeRecentPosts" />,
} as const satisfies CadenceStepsListTypeInt;

export const followLinkedinStep = {
  label: 'Follow',
  labelFull: 'Follow Linkedin',
  labelFullIfResponse: 'Follow Linkedin',
  value: 'follow',
  icon: <StepIcon iconType="follow" />,
} as const satisfies CadenceStepsListTypeInt;

export const siftStep = {
  label: 'Sift',
  labelFull: 'Filter contacts',
  labelFullIfResponse: 'Filter contacts',
  value: 'sift',
  icon: <StepIcon iconType="sift" />,
} as const satisfies CadenceStepsListTypeInt;

export const selectableCadenceStepsList = [
  connectStep,
  messageStep,
  inmailStep,
  likeRecentPostsStep,
  followLinkedinStep,
  visitStep,
  emailStep,
  manualStep,
  voiceNoteStep,
];
export type SelectableCadenceStepsListType = (typeof selectableCadenceStepsList)[number];

export const cadenceStepsList = [
  connectStep,
  messageStep,
  inmailStep,
  visitStep,
  emailStep,
  manualStep,
  callStep,
  likeRecentPostsStep,
  siftStep,
  voiceNoteStep,
];
export type CadenceStepsListType = (typeof cadenceStepsList)[number];

export const triggerSteps: CadenceStepsListType[] = [
  messageStep,
  inmailStep,
  visitStep,
  emailStep,
  manualStep,
  callStep,
];

export const linkedinStepsList = [connectStep, messageStep, inmailStep];
export const otherStepsList = [emailStep];
export const oneOffStepsList = [...linkedinStepsList, ...otherStepsList];
